import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { HttpService } from '../http.service';
import { HelperService } from '../helper.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { AngularFirestore } from '@angular/fire/compat/firestore';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  controller: string = 'admin/auth';
  public user: BehaviorSubject<any> = new BehaviorSubject(undefined);
  userData: any;
  constructor(
    private httpService: HttpService,
    public helperService: HelperService,
    public afs: AngularFirestore,
    public afAuth: AngularFireAuth,
    public ngZone: NgZone,
    private oAuthService: OAuthService,
    private router: Router) {

    if (Object.keys(this.helperService.getLocalStorage('userObj')).length > 0) {
      this.setUser(this.helperService.getLocalStorage('userObj'));
    }
  }
  jump_cloud_login() {
    return this.httpService.post(`${this.controller}/jump_cloud_login`, new Object);
  }
  okta_login() {
    return this.httpService.post(`${this.controller}/okta_login`, new Object);
  }
  google_workspace_login() {
    return this.httpService.post(`${this.controller}/google_workspace_login`, new Object);
  }
  setUser(user: any) {
    this.userData = user;
    this.helperService.setLocalStorage('userObj', this.userData);
    this.user.next(this.userData);
  }
  updateUser(obj: any, type: any) {
    if (type == 'user') {
      this.userData.user = obj;
    }
    else if (type == 'customer_square_details') {
      this.userData.user.customer_square_details = obj;
    }
    this.helperService.setLocalStorage('userObj', this.userData);
    this.user.next(this.userData);
  }

  tenantLogout() {
    return this.httpService.post(`${this.controller}/logout`, new Object);
  }

  tenantForRemoveCurrentSession(){
    this.tenantLogout().subscribe((res:any) =>{
      if(res){
        console.log('')
      }
    } )
  }

  logout(type?: 'jumpcloud') {
    localStorage.removeItem('parentTenant');
    localStorage.removeItem('serverLocation');
    if (this.userData?.admin?.auth_client_type == "jumpcloud" || type == 'jumpcloud') {
      const callScreen = window.open(environment.jumpcloudLogoutURL, '_blank', "width=50,height=50");
      this.tenantForRemoveCurrentSession()
      this.setUser(undefined);
      this.helperService.removeLocalStorage('userObj');
      sessionStorage.clear();
      localStorage.clear();
      this.router.navigateByUrl('/auth/login');
      localStorage.removeItem('tenant')
      setTimeout(() => {
        callScreen!.close();
      }, 3000);
    }
    else if (this.userData?.admin?.auth_client_type == "okta") {
      this.oAuthService.loadDiscoveryDocumentAndTryLogin();
      setTimeout(() => {
        this.tenantForRemoveCurrentSession()
        this.oAuthService.logOut();
        this.setUser(undefined);
        this.helperService.removeLocalStorage('userObj');
        sessionStorage.clear();
        this.router.navigateByUrl('/auth/login');
      }, 0);
    }
    else {
      this.tenantForRemoveCurrentSession()
      this.setUser(undefined);
      this.helperService.removeLocalStorage('userObj');
      sessionStorage.clear();
      this.router.navigateByUrl('/auth/login');
    }
  }
  SignOutFirebase() {
    return this.afAuth.signOut().then(() => {
     setTimeout(() => {
       location.reload()
     }, 500);
   },);
 }
}
